import React, {useState} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton
} from '@material-ui/core';
import FolderSelector from './FolderSelector';
import CloseIcon from "@mui/icons-material/Close";

function MoveFolderItemsDialog(props) {
  const {id, foldersMap, folderList, addFolder, handleMoveSelected, handleClose, open } = props;
  const orderedFolders = [...folderList.filter(f => !foldersMap.hasOwnProperty(f.id)), ...folderList.filter(f => foldersMap.hasOwnProperty(f.id))]
  const [selectedFolder, setSelectedFolder] = useState(orderedFolders[0]);
  const itemCount = Object.entries(foldersMap||{}).map(([id, f]) => f.item_count).reduce((a, b) => a + b, 0);
  const folderIds = Object.entries(foldersMap||{}).map(([id, f]) => f.id);
  const folderCount = folderIds.length;

  const handleMove = () => {
    if(!selectedFolder || typeof(selectedFolder.id) === 'undefined' || !selectedFolder.id){
      return;
    }
    handleMoveSelected(folderIds, selectedFolder.id);
    handleClose();
  };

  return !open || folderCount === 0 ? null : (
    <Dialog PaperProps={{id:id}}
      onClose={handleClose}
      open={open}
    >
      <DialogTitle>
        <div style={{display:'flex', flexWrap:'wrap-reverse', justifyContent:'space-between'}}>
          Move Items from {folderCount > 1 ? `${folderCount} Folders` : 'folder'}
          <IconButton onClick={handleClose} style={{width:'2rem', height:'2rem', margin:'-0.5rem 0 0 auto'}}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="moveFolderItemsMessage">
          Move {itemCount} Items from {folderCount} {folderCount > 1 ? 'folders' : 'folder'} to another folder.
        </DialogContentText>
        <FolderSelector
          label="Folder"
          selectedFolder={selectedFolder}
          folderList={orderedFolders}
          addFolder={addFolder}
          handleFolderSelect={(newVal) => setSelectedFolder(newVal)}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={handleMove}
        >
          Move
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleClose}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default MoveFolderItemsDialog;
